/* global process */
let base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

export const queryInternTableApi = params => {
  return axios.post(`${base}/admin/intern_user/query`, params)
}
export const queryInternLogTableApi = params => {
  return axios.post(`${base}/admin/intern_user/query_log`, params)
}
export const createInternApi = params => {
  return axios.post(`${base}/admin/intern_user/create`, params)
}
export const getInternBaseInfoApi = params => {
  return axios.get(`${base}/admin/intern_user/${params.id}/base`, { params })
}
export const getInternPrivateInfoApi = params => {
  return axios.get(`${base}/admin/intern_user/${params.id}/private`, { params })
}
export const getInternUserDashboardApi = () => {
  return axios.get(`${base}/admin/intern_user/dashboard`)
}
export const activeInternStatusBaseApi = params => {
  return axios.post(`${base}/admin/intern_user/${params.id}/active_status`, params)
}
export const updateAuditInternBaseApi = params => {
  return axios.post(`${base}/admin/intern_user/${params.id}/edit_base`, params)
}
export const updateAuditInternPrivateApi = params => {
  return axios.post(`${base}/admin/intern_user/${params.id}/edit_private`, params)
}
export const updateAuditInternResourceApi = params => {
  return axios.post(`${base}/admin/intern_user/${params.id}/edit_resource`, params)
}
export const convertInternToFulltimeApi = params => {
  return axios.post(`${base}/admin/intern_user/${params.id}/convert_to_fulltime`, params)
}

export const exportInternBaseInfoApi = params => {
  return axios.post(`${base}/admin/intern_user/export_base`, params)
}
export const exportInternFullInfoApi = params => {
  return axios.post(`${base}/admin/intern_user/export_full`, params)
}
export const queryInternMonthlyOnDutyTableApi = params => {
  return axios.post(`${base}/admin/intern_user_onduty/query_monthly`, params)
}
export const queryInternDailyOnDutyTableApi = params => {
  return axios.post(`${base}/admin/intern_user_onduty/query_daily`, params)
}
export const queryInternAuditPerformanceApi = params => {
  return axios.post(`${base}/admin/intern_audit_performance/query`, params)
}
export const recalculateInternAuditPerformanceApi = params => {
  return axios.post(`${base}/admin/intern_audit_performance/recalculate`, params)
}

export const queryAttendanceNotifyCfgTableApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/query`, params)
}
export const getAttendanceNotifyCfgApi = params => {
  return axios.get(`${base}/admin/attendance-notify-cfg/${params.id}`, {params})
}
export const createAttendanceNotifyCfgApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/create`, params)
}
export const editAttendanceNotifyCfgApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/${params.id}/edit`, params)
}
export const activeAttendanceNotifyCfgApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/${params.id}/active`, params)
}
export const inactiveAttendanceNotifyCfgApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/${params.id}/inactive`, params)
}
export const attendanceNotifySentHistoryApi = params => {
  return axios.post(`${base}/admin/attendance-notify-cfg/${params.ref_id}/sent_history`, params)
}
export const queryProjectAttendanceTargetTableApi = params => {
  return axios.post(`${base}/admin/project-attendance-target/query`, params)
}
export const updateProjectAttendanceTargetApi = params => {
  return axios.post(`${base}/admin/project-attendance-target/${params.id}/edit`, params)
}
export const delProjectAttendanceTargetApi = params => {
  return axios.post(`${base}/admin/project-attendance-target/${params.id}/del`, params)
}

export const getOssSignedUrlApi = params => {
  return axios.post(`${base}/admin/oss/get_signed_url`, params)
}
export const forwardCoreApiRoleQueryApi = params => {
  return axios.post(`${base}/admin/core_api/api_role_query`, params)
}
export const forwardCoreApiRoleDetailApi = params => {
  return axios.get(`${base}/admin/core_api/api_role/${params.id}`, { params })
}
export const forwardCoreUiRoleQueryApi = params => {
  return axios.post(`${base}/admin/core_api/ui_role_query`, params)
}
export const forwardCoreUiRoleDetailApi = params => {
  return axios.get(`${base}/admin/core_api/ui_role/${params.id}`, { params })
}



// WEBPACK FOOTER //
// ./src/views/audit-intern/audit-intern.api.js